import React from 'react';
import PropTypes from 'prop-types';
import FieldLabel from '../FieldLabel';

import Toggle from '../Toggle';
import styles from './styles.scss';

const LabeledToggle = ({ label, checked, onChange }) => {
  return (
    <div className={styles.root}>
      <Toggle checked={checked} onChange={onChange} />
      <FieldLabel label={label} />
    </div>
  );
};

LabeledToggle.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
};

export default LabeledToggle;



// WEBPACK FOOTER //
// src/components/shared/LabeledToggle/index.jsx